import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { DetalleTareaService } from './detalle-tareas-service';
import { ComentariosService } from 'app/modules/SharedEntitiesComponents/cometarios/comentarios.service';
import { SolicitudesService } from '../solicitudes/solicitudes.service';
import { UtilsService } from 'app/modules/utils-service';
import { ArchivosSubidosService } from 'app/modules/SharedEntitiesComponents/archivos-subidos/archivos-subidos.service';

@Injectable({
    providedIn: 'root'
})
export class DetalleTareasResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _detalleTareasService: DetalleTareaService,
        private _archivosSubidosService: ArchivosSubidosService,
        private _comentariosService: ComentariosService,
        private _solicitudesService: SolicitudesService,
        private _utilsService: UtilsService,
    )
    {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any>
    {
        const task_uuid = route.paramMap.get('task_uuid');

        // guardamos como entidad activa este uuid para poder realizar gests vinculados a observables 
        this._utilsService.activeEntityUuid = task_uuid;
        
        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
            this._detalleTareasService.getTaskDetails(task_uuid),

            // archivos subidos
            this._archivosSubidosService.getArchivosByEntity(task_uuid),

            // actividades Recientes
            this._detalleTareasService.getActividadesByTask(task_uuid),

            // comentarios
            this._comentariosService.getComentariosByEntity(task_uuid),

            //elementos vinculados
            this._detalleTareasService.getElementosVinculados(task_uuid),

            this._detalleTareasService.getUsuariosAsignados(task_uuid)
        ]);
    }
}




